module.exports = __webpack_public_path__ + "static/img/v72Bg-p.a2aa040.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v72Bg-p.png
// module id = Qyuj
// module chunks = 1